<template>
  <div class="landings flex">
    <div class="cursor" :style="positions" :class="{ black: $store.state.main.blackCursor }">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24.986"
        viewBox="0 0 25 24.986"
      >
        <path
          id="Path_5098"
          data-name="Path 5098"
          d="M507.81,39.931V17.776A1.459,1.459,0,0,1,509.2,16.39h22.134a1.459,1.459,0,0,1,1.036,2.494l-8.54,8.54a1.459,1.459,0,0,1-2.494-1.036V23.077a1.459,1.459,0,0,0-2.494-1.021l-5.367,5.368a1.459,1.459,0,0,0,1.043,2.487h17.036a1.459,1.459,0,0,1,.853,2.458l-8.591,8.591a1.459,1.459,0,0,1-2.472-1.043V33.433h0a1.459,1.459,0,0,0-2.487-1.036L510.3,40.945h0a1.459,1.459,0,0,1-2.494-1.014"
          transform="translate(-507.81 -16.39)"
          fill="#fff"
        />
      </svg>
    </div>

    <div
      class="video-container"
      :class="[{ active: activeType == 'saburtalo' }, { loaded: loaded }]"
      @mousemove="
        $mq == 'tablet' || $mq == 'phone' || $mq == 'xs'
          ? ''
          : activeVideo('saburtalo')
      "
      @click="goTo('saburtalo')"
    >
      <div class="layer"></div>

      <div class="video-container__text">
        <div class="address pangram-bold ">
          {{ content("saburtalo").address }}
        </div>
        <div class="title pangram-bold font-55 uppercase">
          {{ content("saburtalo").title }}
        </div>
        <div class="link flex al-center" @click="goTo('saburtalo')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27.284"
            height="27.279"
            viewBox="0 0 27.284 27.279"
          >
            <path
              id="Path_1587"
              data-name="Path 1587"
              d="M2.91,27.279H30.194V0H2.91Zm24.071-3.208H6.04V18.417h10.54L5.976,7.831l4.766-4.766L21.327,13.651V3.111h5.655Z"
              transform="translate(-2.91)"
              fill="#ffcb05"
            />
          </svg>
          <div class="link-label uppercase">
            {{ $fn.tr("ვიზიტი") }}
          </div>
        </div>
      </div>

      <video
        ref="saburtalo"
        id="saburtalo"
        class="video-container__video"
        muted
        playsinline
        preload="auto"
        loop
      >
        <source :src="content('saburtalo').video" type="video/mp4" />
      </video>
      <picture>
        <source
          class="width-100 height-100"
          media="(max-width: 767px)"
          :srcset="
            _.get(
              this.$store.state.main.indx.widgets,
              'main_page_content.saburtalo-image.[0].devices.mobile'
            )
          "
        />
        <source
          class="width-100 height-100"
          media="(max-width: 1023px)"
          :srcset="
            _.get(
              this.$store.state.main.indx.widgets,
              'main_page_content.saburtalo-image.[0].devices.tablet'
            )
          "
        />
        <img
          class="width-100 height-100"
          :src="
            _.get(
              this.$store.state.main.indx.widgets,
              'main_page_content.saburtalo-image.[0].devices.desktop'
            )
          "
        />
      </picture>
    </div>
    <div
      class="video-container"
      :class="[{ active: activeType == 'gldani' }, { loaded: loaded }]"
      @mousemove="
        $mq == 'tablet' || $mq == 'phone' || $mq == 'xs'
          ? ''
          : activeVideo('gldani')
      "
      @click="goTo('gldani')"
    >
      <div class="layer"></div>
      <div class="video-container__text">
        <div class="address pangram-bold ">
          {{ content("gldani").address }}
        </div>

        <div class="title pangram-bold font-55 uppercase">
          {{ content("gldani").title }}
        </div>
        <div class="link flex al-center" @click="goTo('gldani')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27.284"
            height="27.279"
            viewBox="0 0 27.284 27.279"
          >
            <path
              id="Path_1587"
              data-name="Path 1587"
              d="M2.91,27.279H30.194V0H2.91Zm24.071-3.208H6.04V18.417h10.54L5.976,7.831l4.766-4.766L21.327,13.651V3.111h5.655Z"
              transform="translate(-2.91)"
              fill="#ffcb05"
            />
          </svg>
          <div class="link-label uppercase">
            {{ $fn.tr("ვიზიტი") }}
          </div>
        </div>
      </div>

      <video
        ref="gldani"
        id="gldani"
        preload="auto"
        class="video-container__video"
        muted
        playsinline
        loop
      >
        <source :src="content('gldani').video" type="video/mp4" />
      </video>
      <picture>
        <source
          class="width-100 height-100"
          media="(max-width: 767px)"
          :srcset="
            _.get(
              this.$store.state.main.indx.widgets,
              'main_page_content.gldani-image.[0].devices.mobile'
            )
          "
        />
        <source
          class="width-100 height-100"
          media="(max-width: 1023px)"
          :srcset="
            _.get(
              this.$store.state.main.indx.widgets,
              'main_page_content.gldani-image.[0].devices.tablet'
            )
          "
        />
        <img
          class="width-100 height-100"
          :src="
            _.get(
              this.$store.state.main.indx.widgets,
              'main_page_content.gldani-image.[0].devices.desktop'
            )
          "
        />
      </picture>
    </div>
  </div>
</template>

<script>
import SvgComponents from "../SvgComponents.vue";
export default {
  components: { SvgComponents },
  data() {
    return {
      clientX: "",
      clientY: "",
      changeColor: false,
      activeType: "saburtalo",
      loaded: true
    };
  },
  computed: {
    positions() {
      return {
        transform: `translate(${this.clientX - 5}px,${this.clientY - 98}px)`
      };
    }
  },

  methods: {
    move({ clientX, clientY }) {
      this.clientX = clientX;
      this.clientY = clientY;
    },
    activeVideo(type) {
      this.activeType = type;

      if (this.content(type).video) {
        if (type == "gldani") {
          document.getElementById("saburtalo").pause();
        } else {
          document.getElementById("gldani").pause();
        }
        document.getElementById(type)?.play();
      }

      // var video = document.getElementById(type);

      // var playPromise = video.play();

      // if (playPromise !== undefined) {
      //   playPromise
      //     .then(_ => {
      //       if (type == "gldani") {
      //         document.getElementById("saburtalo").pause();
      //       } else {
      //         document.getElementById("gldani").pause();
      //       }
      //     })
      //     .catch(error => {
      //       // Auto-play was prevented
      //       // Show paused UI.
      //       consolelog(error);
      //     });
      // }
    },
    goTo(type) {
      localStorage.setItem("mallType", this.activeType);
      this.$store.commit("main/setState", {
        key: "mallType",
        val: type
      });
      this.$router.push(`/${this.$store.state.main.locale}/${type}`);
    },
    content(type) {
      const data = _.get(
        this.$store.state.main.indx.widgets,
        "main_page_content"
      );

      const address = data[`address_${type}`];
      const title = data[`title_${type}`];
      const video = data[`video_url_${type}`];
      const image = data[`${type}-image`];
      return { address, title, video, image };
    }
  },
  watch: {
    $mq: {
      immediate: true,

      handler(val) {
        if (val == "tablet" || val == "phone" || val == "xs") {
          setTimeout(() => {
            this.$refs.gldani.addEventListener(
              "pause",
              () => {
                this.$refs.gldani.load();
              },
              false
            );
            this.$refs.saburtalo.addEventListener(
              "pause",
              () => {
                this.$refs.saburtalo.load();
              },
              false
            );

            document.getElementById("gldani")?.play();
            document.getElementById("saburtalo")?.play();
          }, 400);
        }
      }
    }
  },
  mounted() {
    document.getElementById("saburtalo")?.play();

    setTimeout(() => {
      this.loaded = false;
    }, 400);
  },
  created() {
    window.addEventListener("mousemove", this.move);
  },
  destroyed() {
    window.removeEventListener("mousemove", this.move);
  }
};
</script>

<style scoped lang="scss">
@keyframes infiniteLogo {
  0% {
    -webkit-transform: translateX(0px);
  }
  100% {
    -webkit-transform: translateX(-50%);
  }
}
.landings {
  @include screen("desktop") {
    cursor: none;
  }

  width: 100%;
  height: calc(100vh - 94px);
  overflow: hidden;
  background: $black;
  @media (max-width: 1439px) {
    height: calc(100vh - 64px);
  }
  @include screen("mobile") {
    display: flex;
    flex-direction: column;
  }
  .cursor {
    position: fixed;
    z-index: 999999999999;
    transition: 0.05s ease-in-out;
    pointer-events: none;

    @media (max-width: 1023px) {
      display: none;
    }
    path {
      transition: 0.4s ease;
    }
    &.black {
      path {
        fill: #000000;
      }
    }
  }
  .video-container {
    width: 30%;
    height: 100%;
    position: relative;
    transition: 0.6s ease;
    @media (max-width: 1356px) {
      width: 40%;
    }
    @media (max-width: 1024px) {
      width: 50%;
    }
    @include screen("mobile") {
      width: 100%;
      transition: 0.2s ease;
    }
    &:nth-child(even) {
      .address {
        color: $blue;
      }
      .link {
        svg {
          transition: 0.5s ease;

          path {
            fill: $blue;
          }
        }
      }
    }
    &.loaded {
      width: 50vw !important;
      @include screen("mobile") {
        width: 100% !important;
      }
    }

    &.active {
      width: 70%;
      @media (max-width: 1356px) {
        width: 60%;
      }
      @include screen("tablet") {
        width: 50%;
      }
      @include screen("mobile") {
        width: 100%;
      }

      .layer {
        opacity: 0.5;
      }
      .link {
        opacity: 1;
        visibility: visible;
        &:hover {
          svg {
            transform: translate(-5px, 0) rotate(-45deg);
          }
        }
        svg {
          will-change: transform;
          transition: 0.5s ease;
        }
      }
    }
    @include screen("mobile") {
      width: 100% !important;
      animation: unset !important;
    }
    .layer {
      background: #1a1a1a;
      position: absolute;
      width: 100%;
      height: 100%;
      opacity: 0.8;
      z-index: 3;
      transition: 0.4s ease;
      @media (max-width: 1023px) {
        opacity: 0.5;
      }
    }
    &__text {
      position: absolute;
      z-index: 99999999;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      min-width: 200px;
      .address {
        color: $yellow;
        text-align: center;
      }
      .title {
        color: $white;
        margin-bottom: 0px;
        @media (max-width: 1023px) {
          font-size: 34px;
          margin-top: 10px;
        }
      }
      .link {
        display: flex;
        justify-content: center;
        opacity: 0;
        visibility: hidden;
        height: 80px;
        transition: 0.4s ease;
        @media (max-width: 1023px) {
          opacity: 1;
          visibility: visible;
        }

        svg {
          margin-right: 10px;
        }
        .link-label {
          color: $white;
        }
      }
    }
    video {
      z-index: 2;
    }
    img {
      z-index: 1;
    }
    video,
    img {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .long-logo {
    position: absolute;
    bottom: 10vh;
    z-index: 99;
    // animation: infiniteLogo 25s linear infinite;
    display: none;

    @include screen("desktop") {
      display: block;
      svg {
        margin-right: 15px;
      }
    }
  }
}
</style>
